// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"307419c7b158dcadb57e","231":"0aeaff421f2eac6a62e2","610":"f03bcf26d6775a7d078b","691":"f822b0826a21558d19ae","898":"7121e4b5918159bf4d97"}[chunkId] + ".js";
};